import React from 'react';
import AcademicCalendar from '../components/AcademicCalendar';
import Footer from '../components/Footer';

function Calendar() {
  return (
    <>
      <AcademicCalendar />
      <Footer />
    </>
  );
}

export default Calendar;
